var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"item",attrs:{"href":_vm.url,"target":"_blank"}},[(_vm.icon)?_c('app-icon',{staticClass:"item-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))]),_c('app-icon',{staticClass:"item-icon is-after",attrs:{"icon":_vm.iconAfter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }